import angular from 'angular';

angular
  .module('cloudX')
  .controller('ConfigSectionCtrl', [
    '$scope',
    '$timeout',
    'dataCache',
    'resourceFactorySvc',
    'ModalService',
    ConfigSectionCtrl,
  ]);

function ConfigSectionCtrl($scope, $timeout, dataCache, resourceFactorySvc, ModalService) {
  $scope.collapsed = true;
  $scope.loaded = false;
  var colWatch = function(colIndex) {
    var index = colIndex;
    return function(newValues, oldValues) {
      if (!$scope.loaded) return;

      var column = $scope.columns[index];
      for (var pos = 0; pos < column.length; pos++) {
        column[pos].column = parseInt(index);
        column[pos].position = pos;
        column[pos].sectionId = $scope.section.id;
      }
      //console.log("saving");
      resourceFactorySvc.get('sectionConfig').update(column);
    };
  };

  var configWatch = function() {
    var configs = $scope.configs[$scope.section.id] || [];
    var tmpColumns = {
      0: [],
      1: [],
      2: [],
    };

    for (var j = 0; j < configs.length; j++)
      if (configs[j].column < 3) tmpColumns[configs[j].column].push(configs[j]);

    for (var i = 0; i < $scope.section.columns; i++) {
      tmpColumns[i].sort(function(a, b) {
        return a.position - b.position;
      });
      $scope.$watchCollection('columns[' + i + ']', colWatch(i));
    }
    $scope.columns = tmpColumns;
  };
  $scope.$watch('configs', configWatch);

  $scope.getRelevancyInfo = function(value) {
    if (value == null) return 0; //Non selected
    return value.length > 0
      ? 1 //Partial selected
      : 2; //All selected
  };

  $scope.add = function(col) {
    var pos = $scope.columns[col].length || 0;
    ModalService.showModal({
      template: require('./configAddSectionConfig.html'),
      controller: 'ConfigAddSectionConfigCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        sectionId: $scope.section.id,
        column: col,
        position: pos,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) {
          $scope.columns[result.column].push(result);
        }
      });
    });
  };

  $scope.editConfig = function(config) {
    ModalService.showModal({
      template: require('./configEditSectionConfig.html'),
      controller: 'ConfigEditSectionConfigCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        config: config,
        fields: $scope.fields,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result && result.removed) {
          var idx = $scope.columns[result.column].indexOf(config);
          if (idx >= 0) $scope.columns[result.column].splice(idx, 1);
        }
      });
    });
  };
  $timeout(function() {
    $scope.loaded = true;
  }, 100);
}
